import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { getCityList } from 'hooks/carRental/store';

interface PropsType {
  onChange?: any,
  value?: any,
  placeholder?: string,
}

const SPCitySelect: React.FC<PropsType> = (props) => {
  const { onChange, value, placeholder } = props

  const [cityList, setCityList] = useState([]);

  useEffect(() => {
    loadCityList();
  }, [])

  const loadCityList = () => {
    getCityList({}).then((res: any) => {
      const cityList = res?.data?.city_list || [];
      setCityList(cityList);
    });
  }

  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  return (
    <Select
      allowClear
      showSearch
      filterOption={filterOption}
      placeholder={placeholder}
      options={cityList.map((item: any) => ({ label: item.city_name, value: item.city_id }))}
      onChange={(value) => onChange(value)}
    />
  );
};

export default SPCitySelect;
